(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentRequestDeleteController', AgentRequestDeleteController);

    AgentRequestDeleteController.$inject = ['$uibModalInstance', 'entity', 'AgentRequest'];

    function AgentRequestDeleteController($uibModalInstance, entity, AgentRequest) {
        var vm = this;

        vm.agentRequest = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            AgentRequest.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
